export function initHeroDivider(root = document) {
  root.querySelectorAll('.first-sec.home-page .first-sec__text').forEach((text) => {
    const walker = text.ownerDocument.createTreeWalker(text, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      if (!node.textContent.includes('⬝') || node.parentElement.closest('.divider')) return;
      const fragment = text.ownerDocument.createDocumentFragment();
      node.textContent.split('⬝').forEach((part, index) => {
        if (index) {
          const divider = text.ownerDocument.createElement('span');
          divider.className = 'divider';
          divider.textContent = '⬝';
          fragment.append(divider);
        }
        fragment.append(text.ownerDocument.createTextNode(part.trim()));
      });
      node.replaceWith(fragment);
    });
  });
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initHeroDivider());
  } else {
    initHeroDivider();
  }
}
